<template>
  <div>
    <b-row>
      <b-col cols="6">
        <b-form-group>
          <template #label>
            ราคาเต็ม <span class="text-danger">*</span>
          </template>
          <b-input-group append="บาท">
            <b-form-input
              :value="formatNumberInput(form.price)"
              @input="(val) => updateValue('price', val)"
              @keydown="onlyNumberKey"
              placeholder="0"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="ราคาลด (ราคาขายจริง)">
          <b-input-group prepend="ลดเหลือ" append="บาท">
            <b-form-input
              :value="formatNumberInput(form.promotionPrice)"
              @input="(val) => updateValue('promotionPrice', val)"
              @keydown="onlyNumberKey"
              :placeholder="form.price"
              :state="promotionState"
            ></b-form-input>
          </b-input-group>
          <b-form-invalid-feedback :state="promotionState">
            ราคาลดต้องน้อยกว่าราคาเต็ม และมากกว่า 0
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group>
          <template #label>
            ราคาต่อ 1 บทเรียน <span class="text-danger">*</span>
          </template>
          <b-input-group append="บาท">
            <b-form-input
              :value="formatNumberInput(form.pricePerLecture)"
              @input="(val) => updateValue('pricePerLecture', val)"
              @keydown="onlyNumberKey"
              placeholder="0"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cosl="3">
        <b-form-group>
          <template #label>
            จำนวนครั้งที่เรียน <span class="text-danger">*</span>
          </template>
          <b-input-group append="ครั้ง">
            <b-form-input
              :value="formatNumberInput(form.classNumber)"
              @input="(val) => updateValue('classNumber', val)"
              @keydown="onlyNumberKey"
              placeholder="0"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cosl="3">
        <b-form-group label="นาทีที่เรียนต่อครั้ง">
          <b-input-group append="นาที">
            <b-form-input
              :value="formatNumberInput(form.classDuration)"
              @input="(val) => updateValue('classDuration', val)"
              @keydown="onlyNumberKey"
              placeholder="0"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group>
          <template #label>
            วันที่เริ่มเรียน <span class="text-danger">*</span>
          </template>
          <b-input-group class="mb-3">
            <b-form-input
              id="online-start-learning-date"
              :value="formattedStartLearningDate"
              type="text"
              placeholder="วว-ดด-ปปปป"
              autocomplete="off"
              readonly
            ></b-form-input>
            <b-input-group-append>
              <b-form-datepicker
                v-model="startLearningDate"
                button-only
                right
                locale="th-TH"
                aria-controls="online-start-learning-date"
                :min="dateFormat"
                :max="finishLearningDate"
              ></b-form-datepicker>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group>
          <template #label>
            วันที่จบคอร์ส <span class="text-danger">*</span>
          </template>
          <b-input-group class="mb-3">
            <b-form-input
              id="online-end-learning-date"
              :value="formattedFinishLearningDate"
              type="text"
              placeholder="วว-ดด-ปปปป"
              autocomplete="off"
              readonly
            ></b-form-input>
            <b-input-group-append>
              <b-form-datepicker
                v-model="finishLearningDate"
                button-only
                right
                locale="th-TH"
                aria-controls="online-end-learning-date"
                :min="startLearningDate"
              ></b-form-datepicker>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group>
          <template #label>
            ระยะเวลาเรียน <span class="text-danger">*</span>
          </template>
          <b-input-group append="วัน">
            <b-form-input
              :value="formatNumberInput(form.learnDuration)"
              @input="(val) => updateValue('learnDuration', val)"
              @keydown="onlyNumberKey"
              placeholder="0"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="จำนวนชั่วโมงที่สามารถเรียนได้">
          <b-input-group append="ชั่วโมง">
            <b-form-input
              :value="formatNumberInput(form.learnTimeLimit)"
              @input="(val) => updateValue('learnTimeLimit', val)"
              @keydown="onlyNumberKey"
              placeholder="0"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="6" class="mb-4">
        <label>วัน/เวลา ที่เปิดทำรายการสั่งซื้อและรับชำระเงิน</label>
        <DateTimePicker
          v-model="form.openPaymentDateTime"
          :options="openOptions"
          fieldName="OPEN_PAYMENT"
          :courseInfo="courseInfo"
        />
      </b-col>
      <b-col cols="6" class="mb-4">
        <label>วัน/เวลา ที่ปิดทำรายการสั่งซื้อและสิ้นสุดรับชำระเงิน</label>
        <DateTimePicker
          v-model="form.closePaymentDateTime"
          :options="closeOptions"
          fieldName="CLOSE_PAYMENT"
          :courseInfo="courseInfo"
        />
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col cols="12" class="text-right">
        <b-button
          variant="primary"
          @click="submit()"
          :disabled="isRequireFieldsEmpty || !isValidPromotionPrice"
        >
          บันทึก
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Numeral from "numeral";
import DateTimePicker from "../../../shared/DateTimePicker.vue";
import moment from "moment";

export default {
  components: { DateTimePicker },
  computed: {
    ...mapGetters("CourseManagement", ["courseInfo"]),
    isRequireFieldsEmpty() {
      const fields = [
        this.form.price,
        this.form.pricePerLecture,
        this.form.classNumber,
        this.form.learnDuration,
        this.startLearningDate,
        this.finishLearningDate,
      ];

      return fields.some((field) => {
        // Check if null or undefined
        if (field == null) return true;

        // Check if it's a string and empty (after removing spaces)
        if (typeof field === "string" && field.trim() === "") return true;

        return false;
      });
    },
    isValidPromotionPrice() {
      const { price, promotionPrice } = this.form;

      if (!price || !promotionPrice) return true;

      const promo = Numeral(promotionPrice).value() || 0;
      const original = Numeral(price).value() || 0;

      return promo > 0 && promo < original;
    },
    promotionState() {
      const { price, promotionPrice } = this.form;

      if (!price || !promotionPrice) return null;

      return this.isValidPromotionPrice;
    },
    openOptions() {
      return {
        ...this.baseOptions,
        minDate: moment(),
        maxDate: this.form.closePaymentDateTime
          ? this.form.closePaymentDateTime
          : false,
      };
    },
    closeOptions() {
      return {
        ...this.baseOptions,
        minDate: this.form.openPaymentDateTime
          ? this.form.openPaymentDateTime
          : moment(),
      };
    },
    formattedStartLearningDate() {
      return this.formatDate(this.startLearningDate);
    },
    formattedFinishLearningDate() {
      return this.formatDate(this.finishLearningDate);
    },
  },
  data() {
    return {
      form: {
        price: null,
        promotionPrice: null,
        pricePerLecture: null,
        classNumber: null,
        classDuration: null,
        learnDuration: null,
        learnTimeLimit: null,
        openPaymentDateTime: "",
        closePaymentDateTime: "",
      },
      startLearningDate: "",
      finishLearningDate: "",
      baseOptions: {
        singleDatePicker: true,
        showDropdowns: true, // Optional: adds month/year dropdowns for easier nav
        drops: "down",
        timePicker: true, // Enable time
        timePicker24Hour: true, // Use 24h format
        autoUpdateInput: false,
        locale: {
          format: "YYYY-MM-DD HH:mm:ss", // Format for a single date
          daysOfWeek: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
          monthNames: [
            "มกราคม",
            "กุมภาพันธ์",
            "มีนาคม",
            "เมษายน",
            "พฤษภาคม",
            "มิถุนายน",
            "กรกฎาคม",
            "สิงหาคม",
            "กันยายน",
            "ตุลาคม",
            "พฤศจิกายน",
            "ธันวาคม",
          ],
          cancelLabel: "Clear",
        },
      },
      dateFormat: moment().format("YYYY-MM-DD"),
    };
  },
  methods: {
    ...mapActions("CourseManagement", ["updateCourseInfo"]),
    async submit() {
      const cleanNumber = (val, fallback = null) => {
        if (val === null || val === undefined || val === "") return fallback;
        const sanitized = String(val).replace(/,/g, "");
        const num = Number(sanitized);
        return isNaN(num) ? fallback : num;
      };
      const formatDate = (val) => (val ? moment(val).format("YYYY-MM-DD") : "");

      const numberFields = [
        "price",
        "promotionPrice",
        "pricePerLecture",
        "classNumber",
        "classDuration",
        "learnDuration",
        "learnTimeLimit",
      ];

      let params = numberFields.reduce((acc, key) => {
        acc[key] = cleanNumber(this.form[key], null);
        return acc;
      }, {});

      params.startLearningDate = formatDate(this.startLearningDate);
      params.finishLearningDate = formatDate(this.finishLearningDate);
      params.startSellingCourseDate = this.form.openPaymentDateTime ?? "";
      params.openPaymentDateTime = this.form.openPaymentDateTime ?? "";
      params.closePaymentDateTime = this.form.closePaymentDateTime ?? "";

      await this.updateCourseInfo({
        courseId: this.$route.params.courseId,
        attribute: params,
      });
      this.$emit("toggle-modal", "ONLINE");
    },
    formatNumberInput(value) {
      if (!value && value !== 0) return "";
      return Numeral(value).format("0,0");
    },
    updateValue(field, val) {
      this.form[field] = val;
    },
    onlyNumberKey(e) {
      const controlKeys = [
        "Backspace",
        "Delete",
        "Tab",
        "Escape",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
      ];
      if (controlKeys.includes(e.key)) {
        return;
      }

      if (!/^[0-9]$/.test(e.key)) {
        e.preventDefault();
      }
    },
    formatDate(value) {
      if (!value) {
        return "";
      }
      const yearMonthDate = value.split(" ")[0].split("-");
      const thaiYear = parseInt(yearMonthDate[0], 10) + 543;
      return moment(value).format("DD-MM-") + thaiYear;
    },
  },
  watch: {
    courseInfo(newValue) {
      if (!newValue) return;

      const fields = [
        "price",
        "promotionPrice",
        "pricePerLecture",
        "classNumber",
        "classDuration",
        "startLearningDate",
        "finishLearningDate",
        "learnDuration",
        "learnTimeLimit",
      ];

      fields.forEach((key) => {
        this.form[key] = newValue[key] ?? null;
      });

      this.form.openPaymentDateTime = newValue.openPaymentDateTime ?? "";
      this.form.closePaymentDateTime = newValue.closePaymentDateTime ?? "";

      this.startLearningDate = newValue.startLearningDate ?? "";
      this.finishLearningDate = newValue.finishLearningDate ?? "";
    },
  },
};
</script>

<style scoped>
.form-control:disabled,
.form-control[readonly] {
  background-color: #fff !important;
}
</style>
